import { useEffect, useState } from 'react';

import { getInstallMethod, InstallMethod, subscribeToInstallChanges } from '../../services/pwa';

/**
 * The way the web app can be installed from this browser, kept current as the browser
 * offers (or consumes) its native prompt. `none` on native and on desktop.
 */
export const useInstallMethod = (): InstallMethod => {
	const [method, setMethod] = useState<InstallMethod>(() => getInstallMethod());

	useEffect(() => {
		const refresh = () => setMethod(getInstallMethod());
		refresh();
		return subscribeToInstallChanges(refresh);
	}, []);

	return method;
};
